import { ROUTES } from 'routes/_definition';
import ShowcaseToShowcaseTransition from 'common/features/ShowcaseTransition/ShowcaseToShowcaseTransition';
import React from 'react';
import ArtShowcase from 'stacks/ShowcaseNewV2/views/Showcase';
import { usePathParams } from 'routes/routeUtils';
import { useGetShowcaseTransitionProps } from 'common/features/ShowcaseTransition/useGetShowcaseTransitionProps';
import { useFilteredArtworks } from 'common/features/FilteredArtworksList/hooks/useFilteredArtworks';
import { ArtworksListType } from 'store/slices/artworkListModifiers';
import { useGetNextShowroomArtwork } from 'stacks/ArtistProfileShowroom/hooks/useGetNextShowroomArtwork';
import ShowcaseReelContent from 'stacks/ArtistProfileShowroom/components/ShowcaseReelContent';

const ArtistHandleShowroomTitleShowcaseArtworkSlug: React.FC = () => {
  const { title, artistHandle, artworkSlug } =
    usePathParams<ROUTES.ARTIST_HANDLE_SHOWROOM_TITLE_SHOWCASE_ARTWORK_SLUG>();
  const { transitionKey, artworkId, fileId, showcasePreviewSrc } = useGetShowcaseTransitionProps(
    artistHandle ?? '',
    artworkSlug ?? ''
  );

  const hasMoreArtworks = useFilteredArtworks(ArtworksListType.SHOWROOM)?.length > 1;
  const { nextArtworkFound, previousArtworkFound } = useGetNextShowroomArtwork(artistHandle, title, artworkId);

  return (
    <>
      {/* Hotfix because we don't have Showroom to Showcase transition yet (feed-to-showcase-transition-group) */}
      <div style={{ top: 0, position: 'absolute' }} id="feed-to-showcase-transition-group">
        <ShowcaseToShowcaseTransition transitionKey={transitionKey}>
          <ArtShowcase
            artworkId={artworkId}
            primaryImageMetadataId={fileId}
            previewSrc={showcasePreviewSrc}
            hasMoreArtworks={hasMoreArtworks}
            nextArtwork={nextArtworkFound}
            previousArtwork={previousArtworkFound}
            handle={artistHandle}
            slug={artworkSlug}
          >
            <ShowcaseReelContent artistHandle={artistHandle} showroomTitle={title} />
          </ArtShowcase>
        </ShowcaseToShowcaseTransition>
      </div>
    </>
  );
};

export default ArtistHandleShowroomTitleShowcaseArtworkSlug;
